export default function getIgniteService(serviceName) {
  return new Promise((resolve) => {
    const go = () => {
      if (window.ignite && window.ignite[serviceName]) {
        resolve(window.ignite[serviceName]);
      } else {
        console.log(`ignite.${serviceName} not available.  Trying again in 200ms.`);
        window.setTimeout(go, 200);
      }
    };
    go();
  });
}
